import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, TextInput, Dimensions, 
	Image, I18nManager, AsyncStorage, FlatList, Platform } from "react-native";
	
import { format, parse } from 'date-fns'

import * as firebase from "firebase";
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import { ScrollView } from "react-native-gesture-handler";
import PlaceholderComp from "../utilities/PlaceholderComp";
import Main from "../widgets/Main";
import GlowOpacity from "../widgets/GlowOpacity";
import i18n from 'i18n-js';
import MainComponent from "../utilities/MainComponent";
import AppContext from "../utilities/AppContext"
import moment from 'moment';
import { off } from "process";

export default class ReviewScreen extends MainComponent {	
	
	state = {
		store: {currency: ""},
		promoText: "",
		deliveryData: {},
		taxCharges: 0,
		offersDiscount: 0,
		totalPrice: 0,
		deliveryCharges: 0,
		promoDiscount : 0,
		search: "",
		showFullMode 	: true,
		isLoading: false,
		data : [],
		fakeData : new Array(10).fill({})
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
		this.state.totalPrice = 0
				
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	backBtnPressed(){
		var onUpdate = this.context.onUpdate
		onUpdate();
		this.props.navigation.goBack(null)
	}

	getDetails = async () => {		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
			{
				value = JSON.parse(value)			
				this.setState({store: value})
				if(value.status == false)
					this.props.navigation.navigate("menu");
			}

        } catch (error) {
            console.log(error)
		}
		
		try {
			
			var value = await AsyncStorage.getItem(store.promo)
			if (value == undefined)
				value = []
			else
			{
				this.state.promoData = JSON.parse(value)	
				this.state.promoText = this.state.promoData.promoCode
			}

			var mDeliveryData = await AsyncStorage.getItem(store.delivery)
			if (mDeliveryData == undefined)
				mDeliveryData = {name: ""}
			else		
				mDeliveryData = JSON.parse(mDeliveryData)

			try{
				if(this.state.store != undefined && mDeliveryData.area != undefined && this.state.store.locations != undefined)
				{
					this.state.store.locations.forEach(city => {

						if(city.areasList != undefined)
						{
							city.areasList.forEach(area => {
								if (area.name == mDeliveryData.area.name)
								{
									mDeliveryData.area = area
								}
							})
						}
					});

					await AsyncStorage.setItem(store.delivery, JSON.stringify(mDeliveryData))
				}
			}catch{}

			value = await AsyncStorage.getItem(store.key)
			if (value == undefined)
				value = []
			else
			{
				try{
					value = JSON.parse(value)
				} catch (error) {
					value = []
				}
			}	
	
			this.state.deliveryData = mDeliveryData
			this.state.data = value
			this.updatePrice()
		} catch (error) {
			this.setState({isLoading: false})
			console.log(error)
		}
	}

	updatePrice()
	{		
		const {ordersCount, mainTotalPrice, selectedIds, taxCharges, deliveryCharges, promoDiscount, offersDiscount} = this.calculateTotalOrderPrice(
			this.state.data, this.state.store, this.state.deliveryData, this.state.promoData
		)					

		this.setState({offersDiscount: offersDiscount, promoDiscount: promoDiscount, taxCharges: taxCharges, isLoading: false, deliveryData: this.state.deliveryData, deliveryCharges: deliveryCharges, totalPrice: mainTotalPrice, totalCount: ordersCount, selectedIds: selectedIds})				
	}

	reduceCounter(index){
		
		if(this.state.data[index].counter <= 1)
			return
		this.state.data[index].counter = this.state.data[index].counter - 1
		this.setState({data: this.state.data})

		AsyncStorage.setItem(store.key, JSON.stringify(this.state.data)).then((value) => {
		});

		this.updatePrice()
	}

	addCounter(index){	
		this.state.data[index].counter = this.state.data[index].counter + 1
		this.setState({data: this.state.data})
		AsyncStorage.setItem(store.key, JSON.stringify(this.state.data)).then((value) => {
		});
		this.updatePrice()
	}

	removeItem(index){
		this.state.data.splice(index, 1);
		this.setState({data: this.state.data})
		AsyncStorage.setItem(store.key, JSON.stringify(this.state.data)).then((value) => {
		});
		this.updatePrice()
	}

	checkout(){
		this.props.navigation.navigate("checkout");
	}

	openScheduleData(){
		if(this.state.deliveryData == undefined){
			this.state.deliveryData = {area: {}, timings : ""}
		}

		this.context.goBack = true;
		this.context.onUpdate = this.onSelectTimings.bind(this)
		this.props.navigation.navigate('scheduled');
	}

	onSelectTimings = async data => {
		let deliveryData = {area: data.area, timings: data.timings}
		this.setState({deliveryData: deliveryData});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(deliveryData))
	};

	applyPromo(){

		firebase.database().ref('promotions/' + store.storeId).orderByChild("promoCode").equalTo(this.state.promoText).limitToFirst(1).once("value", function(snapshot) {

			let mData = snapshot.val()
			if (mData == undefined){
				this.setState({mainPromo: "", showError: true})
			}else{
			
				let promoData = Object.keys(mData).map(function(key) {
					mData[key].key = key;
					return mData[key];
				})

				if(promoData.length > 0)
				{
					mData = promoData[0]
					var catDataFound = true
					var prodDataFound = true

					if(mData.productsList != undefined && mData.productsList.length > 0)
					{
						prodDataFound = false
						mData.productsList.forEach(item => 
						{
							this.state.data.forEach(productItem => 
							{
								if(productItem.key == item.key)
									prodDataFound = true
							})
						})
					}
					
					if(mData.categoriesList != undefined && mData.categoriesList.length > 0)
					{
						catDataFound = false
						mData.categoriesList.forEach(item => 
							{
								this.state.data.forEach(productItem => 
								{
									if(productItem.categoryId == item.key)
										catDataFound = true
								})
							})
					}
				
					let usageCount = mData.usageLimit - mData.usageCount
						// Need to check if it fulfills the conditions.
					let startDate 	  = (mData.startDate == undefined || mData.startDate == "") ? new Date().getTime() : mData.startDate
					let currentDate   = new Date().getTime()
					let endDate   	  = (mData.endDate == undefined || mData.startDate == "") ? new Date().getTime() : mData.endDate

					if (mData.status == true && usageCount > 0 
						&& mData.minimumPurchase <= this.state.totalPrice
						&& currentDate >= startDate
						&& currentDate <= endDate	
						&& (catDataFound || prodDataFound)	 			
						)
					{
						AsyncStorage.setItem(store.promo, JSON.stringify(mData)).then((value) => {
							this.state.promoData = mData
							this.setState({promoData: mData, showError: false})
							this.updatePrice()
						});
					}
					else{
						this.setState({mainPromo: "", showError: true})
					}
				}else{
					this.setState({mainPromo: "", showError: true})
				}
			}
			
		}.bind(this), function(error) { 
			console.log(error)
		});
	}
	
	openBranch()
	{
		this.props.navigation.navigate("branches");
	}
	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(){

		var promoColor = color.lightGray
		if(this.state.promoText.length > 0){
			promoColor = this.state.store.primaryColor
		}

		var timings = ""
		if(this.state.deliveryData != undefined && this.state.deliveryData.timings != undefined && this.state.deliveryData.timings != "")
		{
			try{
				timings = format(parse(this.state.deliveryData.timings.date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  this.state.deliveryData.timings.data.openingTime + " - " + this.state.deliveryData.timings.data.closingTime
			}catch{
				timings =  i18n.t(this.state.deliveryData.timings.date, {defaultValue: this.state.deliveryData.timings.date})
			}
		}

		var icoName = "ios-arrow-back"
		if(!I18nManager.isRTL)
			icoName = "ios-arrow-forward"
		
		var branchName = ""
		if(this.state.deliveryData != undefined && this.state.deliveryData.branch != undefined)
		{
			branchName = this.state.deliveryData.branch.name + " - " + this.state.deliveryData.branch.address
			if(i18n.locale != this.state.store.defaultLanguage && !!this.state.deliveryData.branch.nameSecondary){
				branchName  = this.state.deliveryData.branch.nameSecondary + " - " + this.state.deliveryData.branch.addressSecondary
			}		
		}

		var isBelowMin = false
		var opacity = 1
		var checkoutText = i18n.t("goToCheckout")

		var deliveryChargesText = "-"
		if(this.state.deliveryData.area != undefined)
		{
			if(I18nManager.isRTL)
				deliveryChargesText = this.state.deliveryCharges.toFixed(3) + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				deliveryChargesText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + this.state.deliveryCharges.toFixed(3)
		}

		var totalPrice = +this.state.totalPrice
		var promoDiscounText = "-"
		if(this.state.promoData != undefined)
		{
			if(I18nManager.isRTL)
				promoDiscounText = this.state.promoDiscount + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				promoDiscounText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + this.state.promoDiscount
		}

		var minOrderValueRequired = this.state.store.minimumOrder
		if(this.state.deliveryData.area != undefined)
		{
			minOrderValueRequired = this.state.deliveryData.area.minOrderPrice
		}

		if(minOrderValueRequired != undefined && totalPrice < minOrderValueRequired){
			isBelowMin = true
			opacity = .6
			checkoutText = i18n.t("minOrder") + " " + minOrderValueRequired + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
		}

		return (
			<View style={styles.container}>

				<ScrollView style={{flex: 1, marginTop: 50}}>

					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
					
				
					{ this.state.deliveryData.area != undefined && (
						<View>												
							<Text style={{textAlign:"left", fontFamily: 'main-bold', color: "black", marginLeft: 15, marginRight: 15, marginTop: 15, fontSize: 16}}>{i18n.t("deliveryInfo")}</Text>
							<TouchableOpacity style={{marginLeft: 15, marginTop: 25, marginBottom: 15, marginRight: 15, flexDirection: "row"}}
								onPress={() => { this.openScheduleData() }}
							>
								<Text style={{fontFamily:'main-regular', color: "black", fontSize: 14}}>{timings}</Text>
								<Ionicons style={{marginLeft: "auto"}} name={icoName} size={20} color={color.detailsColor} />	

							</TouchableOpacity>
						</View>
					)}

					{ this.state.deliveryData.branch != undefined && (
						<View>
							
							<Text style={{textAlign:"left", fontFamily: 'main-bold', color: "black", marginLeft: 15, marginRight: 15, marginTop: 15, fontSize: 16}}>{i18n.t("pickup")}</Text>
							<TouchableOpacity style={{marginLeft: 15, marginTop: 25, marginBottom: 15, marginRight: 15, flexDirection: "row"}}
								onPress={() => { this.openBranch() }}
							>
								<Text style={{fontFamily:'main-regular', color: "black", fontSize: 14}}>{branchName}</Text>
								<Ionicons style={{marginLeft: "auto"}} name={icoName} size={20} color={color.detailsColor} />	

							</TouchableOpacity>

						</View>
					)}
					
					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
					<Text style={{textAlign:"left", fontFamily: 'main-bold', color: "black", marginLeft: 15, marginRight: 15, marginTop: 15, fontSize: 16}}>{i18n.t("orderItems")}</Text>
				
					{!this.state.isLoading && (
						<FlatList
							extraData={this.state}
							showsHorizontalScrollIndicator={false}
							data={this.state.data}
							renderItem={this.renderListItem}
							keyExtractor={(item, index) => item.name + "_" + index}
						/>
					)}

					<View style={{height: 8, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>
					<Text style={{textAlign:'left', fontFamily: 'main-regular', color: "black", marginLeft: 15, marginTop: 20, fontSize: 16, fontWeight:"bold"}}>{i18n.t("promoCode")}</Text>
					<View style={{flex: 1, flexDirection: "row", marginRight: 15, marginLeft: 15, marginTop: 15}}>
						<TextInput 
							placeholder={i18n.t("promoCode")}
							value={this.state.promoText}
							onChangeText={(txt) => this.setState({promoText: txt})}
							style={{outline: "none", textAlign: "left", color: color.detailsColor, height: 30, fontSize: 14, fontWeight:"normal", borderBottomColor: color.bigSeparator, borderBottomWidth: 1, flex: 1, marginRight: 15}}></TextInput>
						<TouchableOpacity disabled={this.state.promoText.length <= 0} style={{
											height:30, justifyContent: "center", alignItems: "center", 
											alignContent: "center", marginLeft: "auto"}}
											onPress={() => { this.applyPromo() }}
									>
										<View style={{width: 85, height: 30, borderColor:color.lightGray, borderRadius: 5, borderWidth: 1, justifyContent: "center", alignItems: "center", alignContent: "center"}}>
										<Text style={{ fontFamily: 'main-regular', color: promoColor, fontSize: 14, fontWeight:"bold",
												textAlign: "center"}}>{i18n.t("apply")}</Text>
									</View>								
						</TouchableOpacity>
					</View>
					{ this.state.showError  && (
						<Text style={{ fontFamily: 'main-regular',marginTop: 25, color: 'red', fontSize: 14, textAlign: "center"}}>{i18n.t("invalidPromo")}</Text>
					)}

					<View style={{height: 8, marginTop: 25, backgroundColor:color.bigSeparator, justifyContent: "center"}}/>

					<View style={{height: 15}} />

					{ this.state.taxCharges >  0 && (
						<View style={{flex: 1, flexDirection: "row", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
								<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14}}>{i18n.t("tax")}</Text>
								{ I18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14, marginLeft: "auto"}}>{this.state.taxCharges.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
								)}
								{ !I18nManager.isRTL && (
									<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14, marginLeft: "auto"}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {this.state.taxCharges.toFixed(3)}</Text>
								)}
								<View style={{height: 10,backgroundColor:'white'}}/>		
						</View>
					)}

					{ this.state.promoData != undefined && (
					<View style={{flex: 1, flexDirection: "row", marginRight: 15, marginLeft: 15, marginTop: 10}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 15, fontWeight:"bold"}}>{i18n.t("promoDiscount")}</Text>
						<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>- {promoDiscounText}</Text>
					</View>
					)}

					{ this.state.offersDiscount != undefined && this.state.offersDiscount > 0 && (
					<View style={{flex: 1, flexDirection: "row", marginRight: 15, marginLeft: 15, marginTop: 10}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 15, fontWeight:"bold"}}>{i18n.t("offersDiscount")}</Text>
						<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>- {this.state.offersDiscount.toFixed(3)}</Text>
					</View>
					)}

					<View style={{flex: 1, flexDirection: "row", marginRight: 15, marginLeft: 15, marginTop: 10}}>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14}}>{i18n.t("delivery")}</Text>
						<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 14, marginLeft: "auto"}}>{deliveryChargesText}</Text>
					</View>
									
					<View style={{flex: 1, flexDirection: "row", marginRight: 15, marginLeft: 15, marginTop: 15}}>
						<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold"}}>{i18n.t("total")}</Text>
						{ I18nManager.isRTL && (
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto"}}>{totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
						)}
						{ !I18nManager.isRTL && (
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto"}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {totalPrice.toFixed(3)}</Text>
						)}
					</View>

					{this.state.isLoading && (
						this.state.fakeData.map((e, i) => <PlaceholderComp key={i} />)
					)}				

				</ScrollView>

				<View style={{height: 85, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
				
					<TouchableOpacity disabled={isBelowMin} style={{opacity: opacity, marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.checkout() }}
								>
					<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
						<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:14}}>{checkoutText}</Text>		
					</View>

					</TouchableOpacity>

				</View>

			</View>
		)
	}

	renderListItem = ({ item, index }) => 
	{	
		var totalPrice = item.price
		var modifiers = ""	
		if (item.counter == undefined)
			item.counter = 1
		
		item.addons.map(mObj => {
			mObj.modifiers.map(obj => {
				totalPrice += obj.price
				if(modifiers == '')
					modifiers = obj.name
				else
					modifiers = modifiers + ", " + obj.name
			})
		})
		
		var shouldEnableMinus = false
		if (item.counter <= 1)
			shouldEnableMinus = true

		var shouldDisablePlus = false
		if(item.mainItem.allowStock)
		{
			var addedStock = 0;
			this.state.data.forEach(data =>{
				if(data.key == item.key)
					addedStock += data.counter
			})	

			if(addedStock >= item.mainItem.stock)
				shouldDisablePlus = true
		}
		

		totalPrice = totalPrice * item.counter	
		return (
			
			<View  style={{backgroundColor:"white"}}>

						{index > 0 && (<View style={{ height: 1, backgroundColor: color.bigSeparator}} />)} 
						<View style={{marginLeft: 15, flex: 1, marginRight: 15, marginTop: 20}}>
							
							<View style={{flexDirection:"row"}}>
							<Text style={{ fontFamily: 'main-bold', color: this.state.store.primaryColor, fontSize: 14 }}>{item.name}</Text>
							{ I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 14, marginLeft: "auto", marginRight:0}}>{totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
							)}
							{ !I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 14, marginLeft: "auto", marginRight:0}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {totalPrice.toFixed(3)} </Text>
							)}
							</View>

							{ modifiers != "" && ( <Text style={{ fontFamily: 'main-regular', fontWeight: "normal", color: "black", fontSize: 12, marginTop: 5 }}>{modifiers}</Text>)} 
							
							<View style={{flex: 1, marginTop: 10, flexDirection: "row", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								
								{ I18nManager.isRTL && (
									<View style={{flexDirection: "row", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
										<TouchableOpacity
												disabled={shouldDisablePlus} 
												onPress={() => { this.addCounter(index) }}
										>
											<Ionicons style={{marginRight: 20}} name="ios-add-circle-outline" size={35} color={color.lightGray} />														

										</TouchableOpacity>
										<Text style={{fontFamily: 'main-regular', color: 'black', 
												fontWeight:"bold", 
												textAlign: "center", fontSize: 15 }}>{item.counter}
										</Text>	
										<TouchableOpacity disabled={shouldEnableMinus} 
												onPress={() => { this.reduceCounter(index) }}
										>
											<Ionicons style={{marginLeft: 20}} name="ios-remove-circle-outline" size={35} color={color.lightGray} />														
										</TouchableOpacity>									
									</View>
								)}

								{ !I18nManager.isRTL && (
									<View style={{flexDirection: "row", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
										<TouchableOpacity disabled={shouldEnableMinus} 
												onPress={() => { this.reduceCounter(index) }}
										>
											<Ionicons style={{marginRight: 20}} name="ios-remove-circle-outline" size={35} color={color.lightGray} />														
										</TouchableOpacity>
										<Text style={{fontFamily: 'main-regular', color: 'black', 
												fontWeight:"bold", 
												textAlign: "center", fontSize: 15 }}>{item.counter}
										</Text>
										<TouchableOpacity
												disabled={shouldDisablePlus} 
												onPress={() => { this.addCounter(index) }}
										>
											<Ionicons style={{marginLeft: 20}} name="ios-add-circle-outline" size={35} color={color.lightGray} />														

										</TouchableOpacity>
									</View>
								)}

								<GlowOpacity
										glowColor={color.detailsColor}
										style={{width: 85, height: 34, borderColor: color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1, backgroundColor:'white', justifyContent: "center", alignItems: "center", alignContent: "center", marginLeft: "auto"}}
										onPress={() => { this.removeItem(index) }}
								>
									<View style={{width: 85, height: 34, justifyContent: "center", alignItems: "center", alignContent: "center"}}>
									<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 13, fontWeight:"bold",
											textAlign: "center"}}>{i18n.t("remove")}</Text>
									</View>								
								</GlowOpacity>
							</View>

							<View style={{height: 10}}/>

						</View>
				</View>
		);
	}
	
	render() {

		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		var that = this
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>	

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails()}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("reviewOrder")}</Text>																						
								</View>	
								<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems:"center"}}
										onPress={() => { 
											var onUpdate = this.context.onUpdate
											if(onUpdate != undefined)
											{
												this.props.navigation.goBack(null) 
												onUpdate();	
											}
											else
												this.props.navigation.navigate("menu");
										}} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails()}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("reviewOrder")}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems:"center"}}
									onPress={() => { 
										var onUpdate = this.context.onUpdate
										if(onUpdate == undefined)
											this.props.navigation.navigate("menu");
										else{
											this.props.navigation.goBack(null) 
											onUpdate();								
										}
									}} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>

		)}
		</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});
